export const QUERY_KEYS = {
	QUOTA: {
		ALL: ['quota'] as const,
		CURRENT: () => [...QUERY_KEYS.QUOTA.ALL, 'current'] as const,
		HISTORY: (query?: Record<string, unknown>) =>
			[...QUERY_KEYS.QUOTA.ALL, 'history', query] as const,
	},
} as const
